<template>
  <div class="my-2 mb-4 pa-2 stringImageBody">
    <v-file-input
      accept="image/*"
      :label="label"
      :hint="hintVal"
      :prepend-icon="prependIcon"
      persistent-hint
      @change="store"
    />
    <img
      v-if="pic"
      :src="pic"
      :alt="label"
      class="StringImageTn my-2 ml-auto"
    />
  </div>
</template>

<script>
export default {
  name: "StringImage",
  props: {
    value: {
      type: String,
      default: null
    },
    size: {
      type: Array,
      default: null
    },
    prependIcon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Изображение"
    },
    hint: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      pic: this.value
    };
  },
  computed: {
    hintSize() {
      if (!Array.isArray(this.size)) return null;
      if (!this.size.length) return null;
      if (this.size.length === 1) return this.size[0];
      return this.size[0] + "×" + this.size[1];
    },
    hintVal() {
      let hint = this.hintSize;
      if (this.hint) {
        if (hint) hint += ", ";
        else hint = "";
        hint += this.hint;
      }
      return hint;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.pic = this.value;
      }
    }
  },
  methods: {
    store(file) {
      if (!file) {
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.$nextTick(() => {
          this.$emit("input", reader.result);
          this.pic = reader.result;
        });
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>
<style lang="scss">
.stringImageBody {
  border: 1px dashed #ccc;
}

.StringImageTn {
  display: block;
  max-width: 100%;
  max-height: 200px;
}
</style>
